import * as React from 'react';

import {ButtonCard} from 'shells/card/button-card';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import type {ConnectStepConfig} from './types';

type Props = {
    step: ConnectStepConfig;
    onClose?: () => void;
};

export function ConnectStep(props: Props) {
    const handleClick = () => {
        if (props.onClose) props.onClose();
        props.step.onClick();
    };

    return (
        <ButtonCard onClick={handleClick}>
            <div className='full-height border-box px-16 py-12'>
                <Stack
                    spacing={12}
                    alignItems='start'
                    isFullHeight={true}
                    justifyContent='space-between'
                >
                    <Stack isHorizontal={true} spacing={8} alignItems='center'>
                        <props.step.icon size={30} wrapWithDiv={false} />
                        <Body color='dark' textAlign='left'>
                            {props.step.title}
                        </Body>
                    </Stack>
                    <Body textAlign='left'>{props.step.description}</Body>
                    <Link
                        onClick={(e) => {
                            e.stopPropagation();
                            handleClick();
                        }}
                        variant='primary'
                    >
                        Get started
                    </Link>
                </Stack>
            </div>
        </ButtonCard>
    );
}
